export const CommissionTypes = {
  Percentage: "Percentage",
  DollarsPerHead: "$/Head",
} as const;

export type CommissionType =
  (typeof CommissionTypes)[keyof typeof CommissionTypes];

export const CommissionOptions = [
  {
    value: CommissionTypes.Percentage,
    label: CommissionTypes.Percentage,
  },
  {
    value: CommissionTypes.DollarsPerHead,
    label: CommissionTypes.DollarsPerHead,
  },
];
